<sidebar />

<navbar />

<div class="container-fluid container-main-nav">
	<router-outlet />
</div>

<app-toast aria-live="polite" aria-atomic="true" class="toast-container" />